@if( offer()?.AdditionalServices?.length > 0) {
<div class="bosysdetail-headerwrapper" id="bosysbookingtemplate">
    <span class="bosysdetail-title">Zusatzleistungen</span>
</div>


<div class="bosysadditionalwrapper">
    @for (ads of offer().AdditionalServices; track $index) {
    <div class="bosysadditionalbody" [style.flex-direction]="mediaServise.deskmode() ? 'row' : 'column'">
        <div>
            <button class="bosysbookingcorsswrapper" (click)="ads.active = !ads.active">
                @if(ads.active) {
                <img src="../../../../assets/tvg/checkboxactive.svg" alt="checkbox">
                } @else {
                <img src="../../../../assets/tvg/checkbox.svg" alt="checkbox">
                }
            </button>
        </div>
        <div class="bosysaddtext">
            @if(ads.text1?.length > 0) {
            <span [innerHTML]="ads.text1"></span>
            }
            @if(ads.text2?.length > 0) {
            <span [innerHTML]="ads.text2"></span>
            }
            @if(ads.text3?.length > 0) {
            <span [innerHTML]="ads.text3"></span>
            }
            @if(ads.text4?.length > 0) {
            <span [innerHTML]="ads.text4"></span>
            }
        </div>
        <div>
            @if(ads?.picture) {
            <img class="bossysaddimg" [src]="ads?.picture" alt="picture">
            }
        </div>
        <div class="bossysaddprice">
            <span>{{ads.price}}</span>
        </div>
    </div>
    }
</div>
}



<div class="bosysdetail-headerwrapper" id="bosysbookingtemplate">
    <span class="bosysdetail-title">Zur Buchung</span>
</div>

@if(offer() && person() && form()) {
@if(bookingsendet()) {
<div class="bookingresponsemessagewrapper">
    @if(bookingsucces()) {
    <span>Sehr {{profileForm?.controls?.['anmelder_anrede']?.value ===
        'Herr' ? 'geehrter' : 'geehrte'}} {{profileForm?.controls?.['anmelder_anrede']?.value + ' ' +
        profileForm?.controls?.['anmelder_vorname']?.value + ' ' +
        profileForm?.controls?.['anmelder_name']?.value}}</span>

    <span>Vielen Dank — Ihre Anmeldung für das <b>Angebot
            {{offer().recID}}</b>
        der Beratung <b>{{offer().offerID}}</b> wurde erfolgreich übermittelt!</span>


    <span>
        Wir werden uns umgehend innerhalb unserer Geschäftszeiten mit Ihnen in Verbindung setzen.
        Die Gültigkeit dieses Angebots kann sich zwischenzeitlich verändert haben.
        Für das endgültige Zustandekommen der Buchung ist die Reisebestätigung des Reisebüros oder des
        Reiseveranstalters relevant.
    </span>
    <span>Ihr Berater {{person().personName}}.</span>
    } @else {
    <span>Bei der Buchung ist ein Fehler aufgetreten, bitte kontaktieren Sie uns unter : {{person().personPhone}}</span>

    <span>Ihr Berater {{person().personName}}</span>
    }
</div>
} @else {
<div class="bosysbookingwrapper">
    @if(offer().CrossMw === 1) {
    <button class="bosysbookingcorsswrapper" (click)="CrossMw.set(!CrossMw())">
        @if(CrossMw()) {
        <img src="../../../../assets/tvg/checkboxactive.svg" alt="checkbox">
        } @else {
        <img src="../../../../assets/tvg/checkbox.svg" alt="checkbox">
        }
        <span>Ich habe Interesse an einem Mietwagen für meine Reise. Bitte senden Sie mir ein
            unverbindliches Angebot zu.</span>
    </button>
    }
    @if(offer().CrossVers === 1) {
    <button class="bosysbookingcorsswrapper" (click)="CrossVers.set(!CrossVers())">
        @if(CrossVers()) {
        <img src="../../../../assets/tvg/checkboxactive.svg" alt="checkbox">
        } @else {
        <img src="../../../../assets/tvg/checkbox.svg" alt="checkbox">
        }
        <span>Ich habe Interesse an einer Reiseversicherung für meine Reise. Bitte senden Sie mir ein unverbindliches
            Angebot zu.</span>
    </button>
    }


    @if(profileForm) {
    <form [formGroup]="profileForm" class="bosysformanmelder">
        <!--Reiseanmelder wrapper-->
        <div class="w100">

            <!--Reiseanmelder-->
            <div class="bosysformtitle">
                <!--Title-->
                <span>
                    Reiseanmelder
                </span>
                <!--end Title-->
            </div>
            <!--Info section-->
            <div class="alert-primary m5">

                <span>
                    Der Reiseanmelder tritt für alle Reiseteilnehmer als Vertragspartner für den Reisevermittler
                    auf und
                    ist auch für die finanzielle Abwicklung verantwortlich.
                    <br><br>
                    Mit * gekennzeichnete Felder sind erforderlich.
                </span>
            </div>
            <!--end Info section-->

            <!--Info Reiseanmelder data-->
            <div class="formcc4">

                <!--Anrede-->
                <div class="formcc5">
                    <div>
                        <mat-button-toggle-group formControlName="anmelder_salutation"
                            [class.mat-form-field-invalid]="!profileForm.controls['anmelder_salutation'].valid && profileForm.controls['anmelder_salutation'].touched">
                            <mat-button-toggle value="H"
                                [style.background]="profileForm.controls['anmelder_salutation'].touched ? '': 'transparent'"
                                [style.color]="!profileForm.controls['anmelder_salutation'].valid && profileForm.controls['anmelder_salutation'].touched ? 'red' : ''">
                                Herr
                            </mat-button-toggle>
                            <mat-button-toggle value="D"
                                [style.background]="profileForm.controls['anmelder_salutation'].touched ? '': 'transparent'"
                                [style.color]="!profileForm.controls['anmelder_salutation'].valid && profileForm.controls['anmelder_salutation'].touched ? 'red' : ''">
                                Frau
                            </mat-button-toggle>
                        </mat-button-toggle-group>
                        <span class="ml5">*</span>
                    </div>
                    @if(!profileForm.controls['anmelder_salutation'].valid &&
                    profileForm.controls['anmelder_salutation'].touched) {
                    <mat-error>
                        Anrede (Pflichtfeld)</mat-error>
                    }
                </div>
                <!--end Anrede-->

                <!--Vorname-->
                <div class="formcc6">
                    <mat-form-field appearance="fill">
                        <mat-label>Vorname</mat-label>
                        <input matInput placeholder="Vorname" name="anmelder_firstname"
                            formControlName="anmelder_firstname" required>
                        <mat-error>Vorname (Pflichtfeld)</mat-error>
                    </mat-form-field>
                </div>
                <!--end Vorname-->

                <!--Nachname-->
                <div class="formcc6">
                    <mat-form-field appearance="fill" color="primary">
                        <mat-label>Nachname</mat-label>
                        <input matInput placeholder="Nachname" name="anmelder_lastname"
                            formControlName="anmelder_lastname" required>
                        <mat-error>Nachname (Pflichtfeld)</mat-error>
                    </mat-form-field>
                </div>
                <!--end Nachname-->

                <!--Strasse-->
                <div class="formcc7">
                    <mat-form-field appearance="fill" color="primary" class="w70"
                        [class.w69]="!mediaServise.deskmode()">
                        <mat-label>Straße</mat-label>
                        <input matInput placeholder="Straße" name="anmelder_strasse" formControlName="anmelder_strasse"
                            required>
                        <mat-error>Straße (Pflichtfeld)</mat-error>
                    </mat-form-field>
                    <mat-form-field appearance="fill" color="primary" class="w28 mt4">
                        <mat-label>HausNr.</mat-label>
                        <input matInput placeholder="HausNr." name="anmelder_hausnummer"
                            formControlName="anmelder_hausnummer" required>
                        <mat-error>Hausnummer (Pflichtfeld)</mat-error>
                    </mat-form-field>
                </div>
                <!--end Strasse-->
            </div>

            <!--ort-->
            <div class="formcc7">
                <mat-form-field appearance="fill" color="primary" class="w28">
                    <mat-label>PLZ</mat-label>
                    <input matInput placeholder="PLZ" name="anmelder_plz" formControlName="anmelder_plz" required>
                    <mat-error>PLZ (Pflichtfeld)</mat-error>
                </mat-form-field>
                <mat-form-field appearance="fill" color="primary" class="w70 mt4"
                    [class.w69]="!mediaServise.deskmode()">
                    <mat-label>Ort</mat-label>
                    <input matInput placeholder="Ort" name="anmelder_wohnort" formControlName="anmelder_wohnort"
                        required>
                    <mat-error>Ort (Pflichtfeld)</mat-error>
                </mat-form-field>
            </div>
            <!--end ort-->

            <!--Land-->
            <div class="formcc8">
                <mat-form-field appearance="fill" color="primary">
                    <mat-select required name="anmelder_land" formControlName="anmelder_land">
                        <mat-option [value]="'de'">Deutschland</mat-option>
                        <mat-option [value]="'at'">Österreich</mat-option>
                        <mat-option [value]="'ch'">Schweiz</mat-option>
                        <mat-divider></mat-divider>
                        @for (co of countryList(); track $index) {
                        <mat-option [value]="co.code">{{co.name}}</mat-option>
                        }
                    </mat-select>
                    <mat-label>Land</mat-label>
                    <mat-error>Land (Pflichtfeld)</mat-error>
                </mat-form-field>
            </div>
            <!--end Land-->

            <!--anmelder_telefon-->
            <div class="formcc7">
                <mat-form-field appearance="fill" color="primary" class="w100">
                    <mat-label>Handynummer</mat-label>
                    <input matInput placeholder="Handynummer" name="anmelder_telefon" formControlName="anmelder_telefon"
                        required>
                    <mat-error>Handynummer (Pflichtfeld)</mat-error>
                </mat-form-field>
            </div>
            <!--end anmelder_telefon-->

            <!--E-Mail-Adresse-->
            <div class="formcc8">
                <mat-form-field appearance="fill" color="primary">
                    <mat-label>E-Mail-Adresse</mat-label>
                    <input matInput placeholder="E-Mail-Adresse" name="anmelder_email" formControlName="anmelder_email"
                        required>
                    <mat-error>E-Mail-Adresse (Pflichtfeld)</mat-error>
                </mat-form-field>
            </div>
            <!--end E-Mail-Adresse-->
        </div>
    </form>
    }

    @if(travelersForm) {
    <form [formGroup]="travelersForm" class="bosysformanmelder">
        <!--Reiseanmelder wrapper-->
        <div class="w100">

            <!--Reiseanmelder-->
            <div class="bosysformtitle">
                <!--Title-->
                <span>
                    Angaben zu den Reisenden
                </span>
                <!--end Title-->
            </div>
            <!--Info section-->
            <div class="alert-primary m5">

                <span>
                    Bitte geben Sie alle Namen exakt wie im Reisepass oder Ausweis an. (auch Zweitnamen und
                    Doppelnamen)
                </span>
            </div>
            <!--end Info section-->

            @for (prs of travelers(); let j = $index; track j) {
            <div class="formcc10">
                @if(prs.Salutation === 'H' || prs.Salutation === 'D') {
                <span>
                    {{j + 1}}. Erwachsener
                </span>
                } @else {
                <span>
                    {{j + 1}}. Kind
                </span>
                }
                <!-- <span>
                            Zimmer {{j + 1}}
                        </span> -->
            </div>

            @if(j === 0) {
            <div class="formcc11">
                <button class="bosysbookingcorsswrapper" (click)="setDisabled()">
                    @if(as_same()) {
                    <img src="../../../../assets/tvg/checkboxactive.svg" alt="checkbox">
                    } @else {
                    <img src="../../../../assets/tvg/checkbox.svg" alt="checkbox">
                    }
                    <span> Ich nehme
                        selbst an der Reise teil.</span>
                </button>
            </div>
            }

            <div class="formcc12">
                <div>
                    <mat-button-toggle-group [formControlName]="(j+1) + '_salutation'"
                        [class.mat-form-field-invalid]="travelersForm.controls[(j+1) + '_salutation'].invalid && (travelersForm.controls[(j+1) + '_salutation'].touched || travelersForm.controls[(j+1) + '_salutation'].disabled)">
                        <mat-button-toggle value="H"
                            [style.color]="travelersForm.controls[(j+1) + '_salutation'].invalid && (travelersForm.controls[(j+1) + '_salutation'].touched || travelersForm.controls[(j+1) + '_salutation'].disabled) ? 'red' : ''">
                            Herr
                        </mat-button-toggle>
                        <mat-button-toggle value="D"
                            [style.color]="travelersForm.controls[(j+1) + '_salutation'].invalid && (travelersForm.controls[(j+1) + '_salutation'].touched || travelersForm.controls[(j+1) + '_salutation'].disabled) ? 'red' : ''">
                            Frau
                        </mat-button-toggle>
                    </mat-button-toggle-group>
                    <span style="margin-left: .5rem;">*</span>
                </div>
                @if(travelersForm.controls[(j+1) + '_salutation'].invalid && ((travelersForm.controls[(j+1) +
                '_salutation'].touched || travelersForm.controls[(j+1) + '_salutation'].disabled))) {
                <mat-error>
                    Anrede (Pflichtfeld)</mat-error>
                }
            </div>

            <div class="formcc6" [style.margin-top]="prs.Salutation === 'H' ? '' : '.5rem'">
                <mat-form-field appearance="fill">
                    <mat-label>Vorname</mat-label>
                    <input matInput placeholder="Vorname" name="{{(j+1) + '_firstname'}}"
                        formControlName="{{(j+1) + '_firstname'}}" required>
                    <mat-error>Vorname (Pflichtfeld)</mat-error>
                </mat-form-field>
            </div>

            <div class="formcc6">
                <mat-form-field appearance="fill" color="primary">
                    <mat-label>Nachname</mat-label>
                    <input matInput placeholder="Nachname" name="{{(j+1) + '_lastname'}}"
                        formControlName="{{(j+1) +  '_lastname'}}" required>
                    <mat-error>Nachname (Pflichtfeld)</mat-error>
                </mat-form-field>
            </div>

            <!--Geburts-->
            <div class="formcc7">
                <!--Tag-->
                <mat-form-field appearance="fill" color="primary" class="formcc13">
                    <mat-select required [formControlName]="(j+1) + '_geburtstag'">
                        <mat-option value="">TT</mat-option>
                        @for (gt of geburtstagdata(); track $index) {
                        <mat-option [value]="gt">{{gt}}</mat-option>
                        }
                    </mat-select>
                    <mat-label>Geburtstag</mat-label>
                    <mat-error>Geburtstag (Pflichtfeld)</mat-error>
                </mat-form-field>
                <!--Monat-->
                <mat-form-field appearance="fill" color="primary" class="formcc13 mt4">
                    <mat-select required [formControlName]="(j+1) + '_monat'">
                        <mat-option value="">MM</mat-option>
                        @for (gt of monatdata(); track $index) {
                        <mat-option [value]="gt">{{gt}}</mat-option>
                        }
                    </mat-select>
                    <mat-label>Monat</mat-label>
                    <mat-error>Monat (Pflichtfeld)</mat-error>
                </mat-form-field>
                <!--Jahr-->
                <mat-form-field appearance="fill" color="primary" class="formcc13 mt4">
                    <mat-select required [formControlName]="(j+1) + '_jahr'">
                        <mat-option value="">JJJJ</mat-option>
                        @for (gt of jahrdata(); track $index) {
                        <mat-option [value]="gt">{{gt}}</mat-option>
                        }
                    </mat-select>
                    <mat-label>Jahr</mat-label>
                    <mat-error>Jahr (Pflichtfeld)</mat-error>
                </mat-form-field>
            </div>
            <!--end Geburts-->

            <!--Nationalität-->
            <div class="formcc8">
                <mat-form-field appearance="fill" color="primary">
                    <mat-select required [formControlName]="(j+1) + '_nationality'">
                        <mat-option [value]="'de'">Deutschland</mat-option>
                        <mat-option [value]="'at'">Österreich</mat-option>
                        <mat-option [value]="'ch'">Schweiz</mat-option>
                        <mat-divider></mat-divider>
                        @for (co of countryList(); track $index) {
                        <mat-option [value]="co.code">{{co.name}}</mat-option>
                        }
                    </mat-select>
                    <mat-label>Nationalität</mat-label>
                    <mat-error>Nationalität (Pflichtfeld)</mat-error>
                </mat-form-field>
            </div>
            <!--end Nationalität-->
            }
        </div>
    </form>
    <mat-form-field class="example-full-width">
        <mat-label>Bemerkung</mat-label>
        <textarea matInput [(ngModel)]="Remark" placeholder="Bemerkung"></textarea>
    </mat-form-field>
    }


    @if(form()?.offer?.PRRL) {
    <button class="bosysbookingcorsswrapper" [class.bosyserror]="paramschecked() && !ReadPRRL()"
        [class.mat-form-field-invalid]="paramschecked() && !ReadPRRL()" (click)="ReadPRRL.set(!ReadPRRL())">
        @if(ReadPRRL()) {
        <img src="../../../../assets/tvg/checkboxactive.svg" alt="checkbox">
        } @else {
        <img src="../../../../assets/tvg/checkbox.svg" alt="checkbox">
        }
        <span>* Ich habe die <a class="bosysbookinga"
                (click)="openInfo(form()?.offer?.PRRL, 'Informationen zur Pauschalreiserichtlinie', $event)">Informationen
                zur Pauschalreiserichtlinie</a> gelesen und verstanden</span>
    </button>
    }

    @if(form()?.offer?.entry_requirements) {
    <button class="bosysbookingcorsswrapper" [class.bosyserror]="paramschecked() && !ReadTRV()"
        [class.mat-form-field-invalid]="paramschecked() && !ReadTRV()" (click)="ReadTRV.set(!ReadTRV())">
        @if(ReadTRV()) {
        <img src="../../../../assets/tvg/checkboxactive.svg" alt="checkbox">
        } @else {
        <img src="../../../../assets/tvg/checkbox.svg" alt="checkbox">
        }
        <span>* Ich habe die <a class="bosysbookinga"
                (click)="openInfo(form()?.offer?.entry_requirements, 'Einreise- und Gesundheitsbestimmungen', $event)">Einreise-
                und
                Gesundheitsbestimmungen</a> gelesen und verstanden</span>
    </button>
    }


    @if(form()?.offer?.agb_office) {
    <button class="bosysbookingcorsswrapper" [class.bosyserror]="paramschecked() && !ReadAGBRB()"
        [class.mat-form-field-invalid]="paramschecked() && !ReadAGBRB()" (click)="ReadAGBRB.set(!ReadAGBRB())">
        @if(ReadAGBRB()) {
        <img src="../../../../assets/tvg/checkboxactive.svg" alt="checkbox">
        } @else {
        <img src="../../../../assets/tvg/checkbox.svg" alt="checkbox">
        }
        <span>* Ich habe die <a class="bosysbookinga"
                (click)="openInfo(form()?.offer?.agb_office, 'Allgemeinen Geschäftsbedingungen (AGB) des Reisebüros', $event)">Allgemeinen
                Geschäftsbedingungen (AGB) des Reisebüros</a> gelesen und verstanden</span>
    </button>
    }
    @if(form()?.offer?.agb_operator) {
    <button class="bosysbookingcorsswrapper" [class.bosyserror]="paramschecked() && !ReadAGBVA()"
        [class.mat-form-field-invalid]="paramschecked() && !ReadAGBVA()" (click)="ReadAGBVA.set(!ReadAGBVA())">
        @if(ReadAGBVA()) {
        <img src="../../../../assets/tvg/checkboxactive.svg" alt="checkbox">
        } @else {
        <img src="../../../../assets/tvg/checkbox.svg" alt="checkbox">
        }
        <span>* Ich habe die <a class="bosysbookinga"
                (click)="openInfo(form()?.offer?.agb_operator, 'Allgemeinen Geschäftsbedingungen (AGB) des Leistungsträgers', $event)">Allgemeinen
                Geschäftsbedingungen (AGB) des Leistungsträgers</a> gelesen und verstanden</span>
    </button>
    }

    <span class="bosysmtop24px">* = erforderliches Feld</span>

    @if(loadingbooking()) {
    <mat-spinner diameter="30"></mat-spinner>
    } @else {
    <button class="bosysbookingbutton" (click)="checkSaises()">Verbindliche Buchungsanfrage senden</button>
    }

</div>
}
}